import { IconBase } from "./iconBase.js";
import { Fragment, jsx, jsxs } from "@emotion/react/jsx-runtime";
//#region src/standardView.tsx
var StandardView = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx("path", {
			d: "M19 4.5C20.3807 4.5 21.5 5.61929 21.5 7V7.5H16.5V4.5H19Z",
			fill: "currentColor",
			stroke: "currentColor"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M21.5 16.5V17C21.5 18.3807 20.3807 19.5 19 19.5H16.5V16.5H21.5Z",
			fill: "currentColor",
			stroke: "currentColor"
		}),
		/* @__PURE__ */ jsx("rect", {
			x: "16.5",
			y: "10.5",
			width: "5",
			height: "3",
			fill: "currentColor",
			stroke: "currentColor"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M6.7998 4.75H13.25V19.25H6.7998C5.94745 19.25 5.35322 19.2497 4.89062 19.2119C4.4368 19.1748 4.17602 19.1055 3.97852 19.0049C3.55515 18.7892 3.21083 18.4448 2.99512 18.0215C2.89449 17.824 2.82517 17.5632 2.78809 17.1094C2.75029 16.6468 2.75 16.0525 2.75 15.2002V8.7998C2.75 7.94745 2.75029 7.35322 2.78809 6.89062C2.82517 6.4368 2.89449 6.17602 2.99512 5.97852C3.21083 5.55515 3.55515 5.21083 3.97852 4.99512C4.17602 4.89449 4.4368 4.82517 4.89062 4.78809C5.35322 4.75029 5.94745 4.75 6.7998 4.75Z",
			stroke: "currentColor",
			strokeWidth: "1.5",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	] }) : /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx("path", {
			d: "M16 4H19C20.6569 4 22 5.34315 22 7V8H16V4Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M16 16H22V17C22 18.6569 20.6569 20 19 20H16V16Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ jsx("rect", {
			x: "16",
			y: "10",
			width: "6",
			height: "4",
			fill: "currentColor"
		}),
		/* @__PURE__ */ jsx("path", {
			d: "M2 7C2 5.34315 3.34315 4 5 4H14V20H5C3.34315 20 2 18.6569 2 17V7Z",
			fill: "currentColor"
		})
	] })
});
//#endregion
export { StandardView };
